import { observer } from 'mobx-react-lite';
import { useStore } from '../../module/rootStore';
import styled from './Tooltip.module.scss'
import Shape from '../../assets/icons/shape.svg'

const Tooltip = () => {
  const { isTooltip, toolTipEmptyHandler, tooltipStepNumber, currentStep } = useStore().StepsStore
  const buttonHandler = () => {
    toolTipEmptyHandler()
  }
  console.log('Tooltip ---> ', isTooltip)
  console.log(tooltipStepNumber === currentStep)
  return (
    <>
      {
        isTooltip && tooltipStepNumber === currentStep &&
        <div className={`${styled.container} ${styled.position}`}>
          <div className={styled.wrapper}>
            Tu ciudad, provincia y
            código postal se localizan automáticamente
            <button onClick={buttonHandler}>Cambiar manualmente</button>
          </div>
          <img className={styled.shape} src={Shape} />
        </div>
      }
    </>

  )
}

export default observer(Tooltip)